import angular from 'angular';
import { get, isEmpty } from 'lodash';

const module = angular.module('whyline.modals.appointment-info', [

]);

 const AppointmentInfoController = ($scope, $uibModalInstance, appointment) => {
  'ngInject';

  $scope.appointment = appointment;

  $scope.appointment.showCompanyData = (
    !isEmpty(get($scope.appointment, 'onBehalfOf.companyCuit', '')) &&
    !isEmpty(get($scope.appointment, 'onBehalfOf.companyName', ''))
  );

   // Close modal
  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };
};

module.exports = module.controller('AppointmentInfoController', AppointmentInfoController);
